
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auto-parts/brands",
      function () {
        return require("private-next-pages/auto-parts/brands.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auto-parts/brands"])
      });
    }
  